'use client';
// Zero MUI / react-content-loader dependency.
// Previously imported useTheme from @mui/material/styles and ContentLoader from
// react-content-loader — both pulled large chunks into the initial bundle.
import { FC } from 'react';

import {
  brandCircleShimmerStyle,
  brandLogosRowStyle,
  brandLogosRowStylePlain,
  chipRowStyle,
  chipShimmerStyle,
  listHeaderStyle,
  SHIMMER_KEYFRAMES,
  titleIconShimmerStyle,
  titleLineShimmerStyle,
  titleRowStyle,
} from './BrandSkeleton.styles';

export const BrandSkeleton: FC = () => (
  <div style={listHeaderStyle}>
    <style>{SHIMMER_KEYFRAMES}</style>
    {/* Title row */}
    <div style={titleRowStyle}>
      <div style={titleIconShimmerStyle} />
      <div style={titleLineShimmerStyle} />
    </div>
    {/* Circular brand logos row */}
    <div style={brandLogosRowStyle}>
      {Array.from({ length: 5 }).map((_, index) => (
        <div key={index} style={brandCircleShimmerStyle} />
      ))}
    </div>
    <div style={brandLogosRowStylePlain}>
      {Array.from({ length: 5 }).map((_, index) => (
        <div key={index} style={brandCircleShimmerStyle} />
      ))}
    </div>
  </div>
);

export const TopBrandSkeleton: FC = () => (
  <div style={listHeaderStyle}>
    <style>{SHIMMER_KEYFRAMES}</style>
    {/* Title row */}
    <div style={titleRowStyle}>
      <div style={titleIconShimmerStyle} />
      <div style={titleLineShimmerStyle} />
    </div>
    {/* Chip row */}
    <div style={chipRowStyle}>
      {Array.from({ length: 8 }).map((_, index) => (
        <div key={index} style={chipShimmerStyle} />
      ))}
    </div>
  </div>
);
